function HeaderMegaMenuDrawer() {
    const summaries = document.querySelectorAll('[id^="Summary-"]');
  
    summaries.forEach(summary => {
        summary.addEventListener('click', function() {
            const drawerId = this.getAttribute('id').replace('Summary-', '');
            const drawerDetails = document.getElementById(`Details-${drawerId}`);
            const drawerContent = document.getElementById(`Content-${drawerId}`);
    
            const isDrawerOpen = drawerContent.classList.contains('open');
    
            closeAllDrawers(drawerContent);
    
            drawerContent.classList.toggle('open');
            drawerDetails.classList.toggle('open');
    
            // Toggle overflow-hidden class on body
            if (drawerContent.classList.contains('open')) {
              document.body.classList.add('overflow-hidden');
            } else {
              document.body.classList.remove('overflow-hidden');
            }
    
            if (!isDrawerOpen) {
                setHeaderHeight();
            }
        });
    });

    const closeTriggers = document.querySelectorAll('[data-mega-menu-drawer-close]');
        closeTriggers.forEach(trigger => {
            trigger.addEventListener('click', function() {
                const drawerContent = document.querySelector('.mega-menu-drawer.open');
                const drawerDetails = document.querySelector('.mega-menu-drawer-container.open');

                drawerContent.classList.remove('open');
                drawerDetails.classList.remove('open');

                document.body.classList.remove('overflow-hidden');

                setHeaderHeight();
            });
        });
    }

  
  function closeAllDrawers(excludeDrawer) {
    const openDrawers = document.querySelectorAll('.mega-menu-drawer.open');
  
    openDrawers.forEach(drawer => {
      // Exclude the drawer being toggled
      if (drawer !== excludeDrawer) {
        const drawerId = drawer.getAttribute('id').replace('Content-', '');
        const drawerDetails = document.getElementById(`Details-${drawerId}`);
        drawer.classList.remove('open');
        drawerDetails.classList.remove('open');
      }
    });
  }
  
  function setHeaderHeight() {
    const header = document.querySelector('.section-header');
    const announcementBar = document.querySelector('.announcement-bar-section');
    let headerHeight = header.offsetHeight;
  
    if (announcementBar) {
      headerHeight += announcementBar.offsetHeight;
    }
  
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  }
  
  HeaderMegaMenuDrawer();